export default __webpack_public_path__ + "static/media/firestore.50d8380a.svg";